module.exports = "\n\n\n<div class=\"content-page\">\n  <!-- Start content -->\n  <div class=\"content\">\n    <div class=\"container\">\n\n      <h1 class=\"alert-danger\"> 404 Page not found</h1>\n\n  </div> <!-- content -->\n\n  <footer class=\"footer text-right\">\n    2015 © Vahagn Davtyan.\n  </footer>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/HP Spectre/Desktop/Regineh Hotel/reginehUser/src/app/page-not-found-component/page-not-found-component.component.html
// module id = ../../../../../src/app/page-not-found-component/page-not-found-component.component.html
// module chunks = main